import React from 'react';

// Connected-nodes brand mark inspired by the Residential Support logo
const BrandMark = ({ size = 36, className = '' }) => {
  const s = size;
  return (
    <svg
      viewBox="0 0 64 64"
      width={s}
      height={s}
      className={className}
      aria-label="Residential Support"
    >
      {/* Dashed connector lines */}
      <g stroke="#9B93B8" strokeWidth="1.2" strokeDasharray="2 2.5" fill="none" strokeLinecap="round">
        <line x1="32" y1="32" x2="44" y2="16" />
        <line x1="32" y1="32" x2="48" y2="32" />
        <line x1="32" y1="32" x2="44" y2="50" />
        <line x1="32" y1="32" x2="18" y2="50" />
        <line x1="32" y1="32" x2="20" y2="18" />
      </g>
      {/* Central node */}
      <circle cx="32" cy="32" r="7" fill="white" stroke="#9B93B8" strokeWidth="1.6" />
      {/* Outer coloured nodes */}
      <circle cx="44" cy="16" r="3.6" fill="#60309C" />
      <circle cx="48" cy="32" r="3.6" fill="#F08C3C" />
      <circle cx="44" cy="50" r="3.6" fill="#4ABEEC" />
      <circle cx="18" cy="50" r="3.6" fill="#E43C48" />
      <circle cx="20" cy="18" r="3.6" fill="#F0C040" />
    </svg>
  );
};

export default BrandMark;
